import { render, staticRenderFns } from "./PosNavigation.vue?vue&type=template&id=e88a11ce"
import script from "./PosNavigation.vue?vue&type=script&lang=js"
export * from "./PosNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports